<!-- <app-sim-sidebar *ngIf="hasFocus" id="sim_sidebar"
[sim_expanded]="sim_expanded"
(onExpand)="expandSimulation()"
></app-sim-sidebar> -->



<div id="simulation_container">





  <div id="simulation_rendering" class="simulation_rendering">

  </div>

  <div id="sizeerror" class="sizeerror">
    <mat-label>Size Error</mat-label>
    <mat-label>The simulation data is too large to render. Please reduce the number of warps and wefts.</mat-label>
  </div>





</div>